import { render, staticRenderFns } from "./black-vip-zone.vue?vue&type=template&id=4c4ac272&scoped=true&"
import script from "./black-vip-zone.vue?vue&type=script&lang=js&"
export * from "./black-vip-zone.vue?vue&type=script&lang=js&"
import style0 from "./black-vip-zone.vue?vue&type=style&index=0&id=4c4ac272&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4ac272",
  null
  
)

export default component.exports